<!-- 📁 src/components/InfoBox.vue -->
<template>
  <div class="info-box">
    <i :class="icon"></i>
    <strong>{{ label }}</strong>
    <span>{{ value || 'No especificado' }}</span>
  </div>
</template>

<script>
export default {
  name: "InfoBox",
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: null },
    icon: { type: String, default: "fa-solid fa-info-circle" } // Icono por defecto
  }
};
</script>

<style scoped>
.info-box {
  background: #f8f8f8;
  padding: 12px;
  border-radius: 6px;
  text-align: center;
  width: 48%;
  display: flex;
  flex-direction: column; /* Asegura que los elementos estén apilados */
  align-items: center; /* Centra horizontalmente */
  justify-content: center; /* Centra verticalmente */
  gap: 5px; /* Espaciado entre icono y texto */
  font-size: 14px;
  min-height: 60px; /* Altura mínima para mantener estructura */
}

.info-box i {
  color: #5b5b5b;
  font-size: 20px;
}
</style>

